import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
// import PersonalDataForm from './PersonalDataForm';
import MedicalDateForm from './date-data/MedicalDateForm';
import PersonalDataForm from './initial-data/PersonalDataForm';
import RecommendationMsg from './summary/RecommendationMsg';
import ConfirmationPersonalData from './confirmation-data/ConfirmationPersonalData';
import UserProvider from './context/UserContext';
import RedirectOnReload from './components/RedirectOnReload';
import { NavigationProvider } from './context/NavigationContext';
import ProtectedRoute from './ProtectedRoute';
import Modal from 'react-modal';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
// after calling LogRocket.init()
if (process.env.NODE_ENV === 'production') {
  setupLogRocketReact(LogRocket);
  LogRocket.init('ceoft/agenda-web');
}
Modal.setAppElement('#root');



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <UserProvider>
      <NavigationProvider>
        <Router>
          <div>
            <RedirectOnReload />
            <Routes>
              <Route path="/" element={<PersonalDataForm />} />
              <Route path="/date" element={
                <ProtectedRoute>
                  <MedicalDateForm />
                </ProtectedRoute>
              } />
              <Route path="/confirmation" element={
                <ProtectedRoute>
                  <ConfirmationPersonalData />
                </ProtectedRoute>
              } />
              <Route path="/summary" element={
                <ProtectedRoute>
                  <RecommendationMsg />
                </ProtectedRoute>
              } />
            </Routes>
          </div>
        </Router>
      </NavigationProvider>
    </UserProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
